import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';
import type { SelectOptionWithColor } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';
import { useEffect, useState } from 'react';

import type { TripRead } from 'src/common/external/bambi-api/bambiApi';
import { useTagsListQuery } from 'src/common/external/bambi-api/bambiApi';
import type { TripSubscriptionRead } from 'src/common/external/bambi-api/tripsApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelect } from 'src/common/primitives/MultiSelect/MultiSelect';

interface TripTagsContextFieldsProps {
  fieldPath: string;
  label: string;
  selectedEntity?: TripRead | TripSubscriptionRead;
}

export default function TripTagsContextField({
  fieldPath,
  label,
  selectedEntity,
}: TripTagsContextFieldsProps) {
  const { data: orgTags } = useTagsListQuery({});

  const [options, setOptions] = useState<SelectOptionWithColor[]>([]);

  useEffect(() => {
    if (orgTags?.results.length) {
      if (selectedEntity?.tags?.length) {
        const tagsNotOnTrip = orgTags.results.filter(
          (tag) =>
            !selectedEntity.tags?.find((tripTag) => tripTag.tag === tag.id)
        );

        setOptions(
          tagsNotOnTrip.map((tag) => ({
            label: tag.tag_name,
            value: tag.id,
            color: tag.color_hex || '',
          }))
        );
      } else {
        setOptions(
          orgTags.results.map((tag) => ({
            label: tag.tag_name,
            value: tag.id,
            color: tag.color_hex || '',
          }))
        );
      }
    }
  }, [selectedEntity?.tags, orgTags]);

  return (
    <FormFieldController name={fieldPath}>
      {({ field, fieldState }) => {
        return (
          <FormFieldContainer>
            <DefaultFormFieldLayout
              label={label}
              error={fieldState.error?.message?.toString()}
              inputId={fieldPath}
            >
              <MultiSelect
                options={options}
                selected={field.value}
                onChange={(selected) => {
                  field.onChange(selected);
                }}
              />
            </DefaultFormFieldLayout>
          </FormFieldContainer>
        );
      }}
    </FormFieldController>
  );
}
